export default __webpack_public_path__ + "static/media/tile_2.0063ecf4.png";